<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AlertServices from "@/services/api/alert.api";
import ReportServices from '@/modules/report/api';
import DocumentServices from '@/modules/report/document';

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Alertas Generadas en el Sistema',
      routes: ["Informes", "Alertas Generadas en el Sistema"]
    },
    model: {
      search: {
        collections: {
          alertsTypes: [],
          dateTo: [],
          sie: [],
        },
        filters: {
          alertType: null,
          dateTo: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: 'Fecha',
          placeholder: 'Seleccionar Fecha',
          error: "Fecha es requerida.",
          validations: "required",
          class: 'col-md-3',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
        {
          name: 'alertType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Alerta',
          placeholder: 'Seleccionar',
          error: "Tipo de Alerta.",
          validations: "required",
          class: "col-md-6",
          options: this.model.search.collections.alertsTypes,
          value: this.model.search.filters.alertType,

        },
        {
        name: 'sie',
        component: 'CustomInput',
        type: 'text',
        label: 'SIE',
        placeholder: 'Escriba número de SIE',
        icon: 'fa fa-search orange-icon',
        class: "col-md-3",
        leftIcon: true,
        value: this.model.search.filters.sie,
        disabled: this.model.search.filters.sieDisabled,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
        await AlertServices.getAlertType()
        .then(res => this.model.search.collections.alertsTypes = res.data);

    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {
      await ReportServices.getReport('generatedalerts', {
        alertDate:  this.model.search.filters.dateTo,
        alertTypeId: this.model.search.filters.alertType?.id ?? -1,
        studentSieId: this.model.search.filters?.sie ?? ""
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>